import React from "react"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const Resume = () => {
  return (
    <OutboundLink
      href="https://drive.google.com/drive/folders/1oGaNuTU4QJRT0zmCBjmI0ztx_3DNRjN9?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      className="navbar__link navbar__resume btn btn--secondary"
    >
      Resume
    </OutboundLink>
  )
}

export default Resume
